/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import styled from 'styled-components';
import { NavLink } from 'react-router';
import { BreadCrumb, BreadCrumbProps } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import React from 'react';
import logo from '@/assets/img/antflow-logo.png';
import { useThemeContext } from '@/contexts/ThemeContext';

export const AnchorDiv = styled.div`
  padding: 0 var(--site-padding-x);
`;

export const CNavLink = styled(NavLink)`
  all: unset;
  cursor: pointer;
  padding: 3px 5px;
  &:hover {
    background: var(--surface-hover);
  }
`;

const CBreadCrumb = styled(BreadCrumb)`
  border: 0;
  padding-left: 0;
  display: flex;
  background-color: transparent !important;
  li:last-child {
    font-weight: bold;
  }
`;

export const CButtonRounded = styled(Button)`
  height: 35px;
  width: 35px;
`;

export const CBreadCrumbs: React.FC<BreadCrumbProps> = (props) => {
  const { brandThemes } = useThemeContext();
  return (
    <div className="w-full flex align-items-center justify-content-between">
      <CBreadCrumb separatorIcon={<i className="pi pi-angle-right text-md sm:flex-wrap" />} {...props} />
      {brandThemes?.branding && (
        <NavLink to={'/'} className="no-underline text-2xl text-primary font-bold flex align-items-center">
          <img src={logo} height={30} alt="AntFlow Logo" className="mx-1" />
          <span className="antflow-logo">AntFlow</span>
        </NavLink>
      )}
    </div>
  );
};
